export enum TEMPERATURE_UNIT_TYPES {
  CELSIUS = 'CELSIUS',
  FAHRENHEIT = 'FAHRENHEIT',
  DONT_CARE = 'DONT_CARE',
}
export const DEFAULT_TEMPERATURE_UNIT = TEMPERATURE_UNIT_TYPES.CELSIUS;
export const DEFAULT_NUMBER_DECIMALS_SAVE = 4;
export const DEFAULT_NUMBER_DECIMALS_SHOW = 0;
